import axios from 'axios';
import { parse, format } from 'date-fns';
import settings from '@/settings.js';

let service = {
	getUser (loginUser) {
		return axios.post(process.env.API_BASE_URL + 'api/v1/get_user', loginUser);
	},
	getUsers (ctx, filter) {
		let query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		query += '&search=' + ctx.filter;
		return axios.get(process.env.API_BASE_URL + 'api/v1/get_users?' + query).then(response => {
			return response.data;
		});
	},
	getProdajalci () {
		return axios.get(process.env.API_BASE_URL + 'api/v1/get_prodajalci').then(response => {
			return response.data;
		});
	},
	addUser (user) {
		return axios.post(process.env.API_BASE_URL + 'api/v1/add_user', user).then(response => {
			return response.data;
		});
	},
	removeUser (user) {
		return axios.post(process.env.API_BASE_URL + 'api/v1/remove_user', user).then(response => {
			return response.data;
		});
	},
	addFiltersToQueryVozilaFiltered (filter, user) {
		let filtersQuery = '';
		if (filter.konto_destinacije) {
			for (let item of filter.konto_destinacije) {
				filtersQuery += '&konto[]=' + encodeURIComponent(item);
			}
		}
		filtersQuery += '&st_narocila_kupca=' + encodeURIComponent(filter.st_narocila_kupca);
		filtersQuery += '&st_narocila_vozila=' + encodeURIComponent(filter.st_narocila_vozila);
		filtersQuery += '&ogrodje=' + encodeURIComponent(filter.ogrodje);
		filtersQuery += '&model=' + encodeURIComponent(filter.model);
		filtersQuery += '&verzija=' + encodeURIComponent(filter.verzija);
		filtersQuery += '&barva=' + encodeURIComponent(filter.barva);
		filtersQuery += '&staranje=' + encodeURIComponent(filter.staranje);
		filtersQuery += '&vega_dhsVegaSalesId=' + encodeURIComponent(filter.vega_dhsVegaSalesId);
		filtersQuery += '&vega_brand=' + encodeURIComponent(filter.vega_brand);
		filtersQuery += '&vega_status=' + encodeURIComponent(filter.vega_status);
		filtersQuery += '&predvideni_mada=' + encodeURIComponent(filter.predvideni_mada);
		if (filter.stanje) {
			for (let item of filter.stanje) {
				filtersQuery += '&stanje[]=' + encodeURIComponent(item);
			}
		}
		if (filter.status) {
			for (let item of filter.status) {
				filtersQuery += '&status[]=' + encodeURIComponent(item);
			}
		}
		if (filter.lokacije) {
			for (let item of filter.lokacije) {
				filtersQuery += '&lokacije[]=' + encodeURIComponent(item);
			}
		}
		if (filter.prodaja) {
			for (let item of filter.prodaja) {
				filtersQuery += '&prodaja[]=' + encodeURIComponent(item);
			}
		}
		if (filter.prodajalec) {
			filtersQuery += '&prodajalec=' + filter.prodajalec;
		}
		if (filter.kupec) {
			filtersQuery += '&kupec=' + filter.kupec;
		}
		if (filter.rmadc) {
			filtersQuery += '&rmadcstart=' + format(filter.rmadc.start, settings.inputDtFormat) + '&rmadcend=' + format(filter.rmadc.end, settings.inputDtFormat);
		}
		if (filter.pmadc) {
			filtersQuery += '&pmadcstart=' + format(filter.pmadc.start, settings.inputDtFormat) + '&pmadcend=' + format(filter.pmadc.end, settings.inputDtFormat);
		}
		if (filter.omada) {
			filtersQuery += '&omadastart=' + format(filter.omada.start, settings.inputDtFormat) + '&omadaend=' + format(filter.omada.end, settings.inputDtFormat);
		}
		if (filter.pdp) {
			filtersQuery += '&pdpstart=' + format(filter.pdp.start, settings.inputDtFormat) + '&pdpend=' + format(filter.pdp.end, settings.inputDtFormat);
		}
		if (filter.datum_prve_registracije) {
			filtersQuery += '&datum_prve_registracije_start=' + format(filter.datum_prve_registracije.start, settings.inputDtFormat) + '&datum_prve_registracije_end=' + format(filter.datum_prve_registracije.end, settings.inputDtFormat);
		}
		if (filter.datum_kdaj_ga_moramo_prodati) {
			filtersQuery += '&datum_kdaj_ga_moramo_prodati_start=' + format(filter.datum_kdaj_ga_moramo_prodati.start, settings.inputDtFormat) + '&datum_kdaj_ga_moramo_prodati_end=' + format(filter.datum_kdaj_ga_moramo_prodati.end, settings.inputDtFormat);
		}
		if (filter.datum_kdaj_ga_lahko_prodamo) {
			filtersQuery += '&datum_kdaj_ga_lahko_prodamo_start=' + format(filter.datum_kdaj_ga_lahko_prodamo.start, settings.inputDtFormat) + 'datum_kdaj_ga_lahko_prodamo_end=' + format(filter.datum_kdaj_ga_lahko_prodamo.end, settings.inputDtFormat);
		}
		if (filter.obljubljenaDobava) {
			filtersQuery += '&odstart=' + format(filter.obljubljenaDobava.start, settings.inputDtFormat) + '&odend=' + format(filter.obljubljenaDobava.end, settings.inputDtFormat);
		}
		filtersQuery += '&arhiv=' + encodeURIComponent(filter.arhiv);
		filtersQuery += '&nissan=' + encodeURIComponent(filter.nissan);
		filtersQuery += '&manual=' + encodeURIComponent(filter.manual);
		filtersQuery += '&user_id=' + encodeURIComponent(user.dbid);
		filtersQuery += '&user_role=' + encodeURIComponent(user.role);
		return filtersQuery;
	},
	getVozilaFiltered (ctx, filter, user) {
		let query = 'page=' + encodeURIComponent(ctx.currentPage);
		query += '&size=' + encodeURIComponent(ctx.perPage);
		query += '&sort=' + encodeURIComponent(ctx.sortBy);
		query += '&desc=' + encodeURIComponent(ctx.sortDesc);
		query += '&search=' + encodeURIComponent(ctx.filter);
		query += this.addFiltersToQueryVozilaFiltered(filter, user);
		return axios.get(process.env.API_BASE_URL + 'api/v1/items?' + query).then(response => {
			return response.data;
		});
	},
	getVozilaToConfirm (ctx, filter) {
		let query = 'page=' + encodeURIComponent(ctx.currentPage);
		query += '&size=' + encodeURIComponent(ctx.perPage);
		query += '&sort=' + encodeURIComponent(ctx.sortBy);
		query += '&desc=' + encodeURIComponent(ctx.sortDesc);
		if (filter.ogrodje) {
			query += '&ogrodje=' + filter.ogrodje;
		}
		if (filter.libelle_modele) {
			query += '&libelle_modele=' + filter.libelle_modele;
		}
		if (filter.libelle_version) {
			query += '&libelle_version=' + filter.libelle_version;
		}
		if (filter.p_prodajalec_name) {
			query += '&p_prodajalec_name=' + filter.p_prodajalec_name;
		}
		if (filter.st_racuna) {
			query += '&st_racuna=' + filter.st_racuna;
		}
		if (filter.datum_racunovodja_potrdil) {
			query += '&datum_racunovodja_potrdil_start=' + format(filter.datum_racunovodja_potrdil.start, settings.inputDtFormat) + '&datum_racunovodja_potrdil_end=' + format(filter.datum_racunovodja_potrdil.end, settings.inputDtFormat);
		}
		return axios.get(process.env.API_BASE_URL + 'api/v1/get_vozila_to_confirm?' + query).then(response => {
			return response.data;
		});
	},
	getRacuniZaIzstavit (ctx, user) {
		let query = 'page=' + encodeURIComponent(ctx.currentPage);
		query += '&size=' + encodeURIComponent(ctx.perPage);
		query += '&user_role=' + encodeURIComponent(user.role);
		return axios.get(process.env.API_BASE_URL + 'api/v1/get_racuni_za_izstavit?' + query).then(response => {
			return response.data;
		});
	},
	searchVozila (qs) {
		let args = {
			qs
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/search', args).then(response => {
			return response.data;
		});
	},
	uvoziVozila (zalogaRenault, prodajaRenault, zalogaDacia, prodajaDacia) {
		let args = {
			zalogaRenault: zalogaRenault,
			prodajaRenault: prodajaRenault,
			zalogaDacia: zalogaDacia,
			prodajaDacia: prodajaDacia
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/import', args).then(response => {
			return response.data;
		});
	},
	rezervirajVozilo (itemId, prodajalec, kupec, trajanje) {
		let args = {
			itemId: itemId,
			prodajalec: prodajalec,
			kupec: kupec,
			trajanje: trajanje
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/reserve', args).then(response => {
			return response.data;
		});
	},
	prodajVozilo (itemId, prodajaId, prodajalec, kupec, datumProdaje, datumPlaniraneIzdaje, urejenoFinanciranje, vlozeno, podpisano, financiranjeRci, external) {
		let args = {
			itemId: itemId,
			prodajaId: prodajaId,
			prodajalec: prodajalec,
			kupec: kupec,
			datumProdaje: datumProdaje,
			datumPlaniraneIzdaje: datumPlaniraneIzdaje,
			urejenoFinanciranje: urejenoFinanciranje,
			vlozeno: vlozeno,
			podpisano: podpisano,
			financiranje_rci: financiranjeRci,
			external: external
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/sell', args).then(response => {
			return response.data;
		});
	},
	stornirajProdajo (prodajaId) {
		let args = {
			prodajaId: prodajaId
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/cancel_sell', args).then(response => {
			return response.data;
		});
	},
	stornirajRezervacijo (rezervacijaId) {
		let args = {
			rezervacijaId: rezervacijaId
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/cancel_reservation', args).then(response => {
			return response.data;
		});
	},
	dobavivKoncesijo (itemId, prodajalec, lokacija, datumDobave) {
		let args = {
			itemId: itemId,
			prodajalec: prodajalec,
			lokacija: lokacija,
			datumDobave: datumDobave
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/dobavavkoncesijo', args).then(response => {
			return response.data;
		});
	},
	zadrziVozilo (itemId, lastnik) {
		let args = {
			itemId: itemId,
			lastnik: lastnik
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/zadrzivozilo', args).then(response => {
			return response.data;
		});
	},
	urediOpomboVozilo (itemId, opomba, akcijski) {
		let args = {
			itemId: itemId,
			opomba: opomba,
			akcijski: akcijski
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/urediopombovozila', args).then(response => {
			return response.data;
		});
	},
	getIzdaje (start, end) {
		let args = {
			start,
			end
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/getizdaje', args).then(response => {
			return response.data;
		});
	},
	dodajIzdajo (izdajaId, prodajalec, kupec, datumIzdaje, voziloInt, voziloExt, opomba) {
		let args = {
			izdajaId,
			prodajalec,
			kupec,
			datumIzdaje,
			voziloInt,
			voziloExt,
			opomba
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/dodajizdajo', args).then(response => {
			return response.data;
		});
	},
	odstraniIzdajo (izdajaId) {
		let args = {
			izdajaId
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/odstraniizdajo', args).then(response => {
			return response.data;
		});
	},
	getKupci () {
		return axios.get(process.env.API_BASE_URL + 'api/v1/get_kupci').then(response => {
			return response.data;
		});
	},
	searchKupci (qs) {
		let args = {
			qs
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/search_kupci', args).then(response => {
			return response.data;
		});
	},
	searchKupecById (id) {
		let config = {
			timeout: settings.responseTimeout
		}
		let args = {
			id: id
		}
		return axios.post(process.env.API_BASE_URL + 'api/v1/search_kupec_by_id', args, config).then(response => {
			return response.data;
		});
	},
	getKupciFiltered (ctx, filter) {
		let query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		query += '&search=' + ctx.filter;
		return axios.get(process.env.API_BASE_URL + 'api/v1/get_kupci_filtered?' + query).then(response => {
			return response.data;
		});
	},
	addKupec (kupec) {
		return axios.post(process.env.API_BASE_URL + 'api/v1/add_kupec', kupec).then(response => {
			return response.data;
		});
	},
	removeKupec (kupec) {
		return axios.post(process.env.API_BASE_URL + 'api/v1/remove_kupec', kupec).then(response => {
			return response.data;
		});
	},
	saveMapa (itemId, podaljsanoJamstvoPicked, podaljsanoJamstvoLeta, podaljsanoJamstvoKm, podaljsanoJamstvoZnesek, podaljsanoJamstvoOpomba, zavarovanjePicked, zavarovanjeOpomba, myrPicked, myrLeta, myrKm, myrZnesek, myrOpomba, gapPicked, gapOpomba, bniPicked, bniOpomba, bonus1, bonus2, bonus3, bonus4, bonus5, bonus6, ostaliDogovori, nultiPicked, ciscenje, klicStranke, stRacuna, datumRacuna, prodajnaCena, skupniZnesek, rciLizing, rciKredit, starost, nakazila, nakazilaToDelete, povracila, povracilaToDelete, oprema, dodatneopremeToDelete, stopnjaDDV) {
		if (datumRacuna) {
			datumRacuna = format(datumRacuna, settings.dbDtFormat);
		}
		for (let nakazilo of nakazila) {
			if (nakazilo['datum']) {
				nakazilo['datum'] = format(nakazilo['datum'], settings.dbDtFormat);
			}
		}
		for (let povracilo of povracila) {
			if (povracilo['datum']) {
				povracilo['datum'] = format(povracilo['datum'], settings.dbDtFormat);
			}
		}
		for (let dodatnaoprema of oprema) {
			if (dodatnaoprema['datum_narocila']) {
				dodatnaoprema['datum_narocila'] = format(dodatnaoprema['datum_narocila'], settings.dbDtFormat);
			}
		}
		let args = {
			item: itemId,
			podaljsano_jamstvo: podaljsanoJamstvoPicked,
			podaljsano_jamstvo_leta: podaljsanoJamstvoLeta,
			podaljsano_jamstvo_km: podaljsanoJamstvoKm,
			podaljsano_jamstvo_znesek: podaljsanoJamstvoZnesek,
			podaljsano_jamstvo_opomba: podaljsanoJamstvoOpomba,
			zavarovanje: zavarovanjePicked,
			zavarovanje_opomba: zavarovanjeOpomba,
			myr: myrPicked,
			myr_leta: myrLeta,
			myr_km: myrKm,
			myr_znesek: myrZnesek,
			myr_opomba: myrOpomba,
			gap: gapPicked,
			gap_opomba: gapOpomba,
			bni: bniPicked,
			bni_opomba: bniOpomba,
			bonus1: bonus1,
			bonus2: bonus2,
			bonus3: bonus3,
			bonus4: bonus4,
			bonus5: bonus5,
			bonus6: bonus6,
			ostali_dogovori: ostaliDogovori,
			nulti: nultiPicked,
			ciscenje: ciscenje,
			klic_stranke: klicStranke,
			st_racuna: stRacuna,
			datum_racuna: datumRacuna,
			prodajna_cena: prodajnaCena,
			skupni_znesek: skupniZnesek,
			rci_lizing: rciLizing,
			rci_kredit: rciKredit,
			starost: starost,
			nakazila: nakazila,
			nakazila_to_delete: nakazilaToDelete,
			povracila: povracila,
			povracila_to_delete: povracilaToDelete,
			dodatneopreme: oprema,
			dodatneopreme_to_delete: dodatneopremeToDelete,
			stopnja_ddv: stopnjaDDV
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/save_mapa', args).then(response => {
			return response.data;
		});
	},
	getMapa (itemId) {
		let args = {
			item: itemId
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/get_mapa', args).then(response => {
			if (!response.data) {
				return null;
			}
			if (!response.data['mapa'] || response.data['mapa'] === false) {
				return null;
			}
			if (response.data['mapa']['datum_racuna']) {
				response.data['mapa']['datum_racuna'] = parse(response.data['mapa']['datum_racuna'], settings.dbDtFormat);
			}
			if (response.data['mapa']['datum_prodajalec_potrdil']) {
				response.data['mapa']['datum_prodajalec_potrdil'] = parse(response.data['mapa']['datum_prodajalec_potrdil'], settings.dbDtFormat);
			}
			if (response.data['mapa']['datum_sekretar_potrdil']) {
				response.data['mapa']['datum_sekretar_potrdil'] = parse(response.data['mapa']['datum_sekretar_potrdil'], settings.dbDtFormat);
			}
			if (response.data['mapa']['datum_admin_potrdil']) {
				response.data['mapa']['datum_admin_potrdil'] = parse(response.data['mapa']['datum_admin_potrdil'], settings.dbDtFormat);
			}
			for (let nakaziloFromDb of response.data['mapa']['nakazila']) {
				if (nakaziloFromDb['datum']) {
					nakaziloFromDb['datum'] = parse(nakaziloFromDb['datum'], settings.dbDtFormat);
				}
			}
			for (let povraciloFromDb of response.data['mapa']['povracila']) {
				if (povraciloFromDb['datum']) {
					povraciloFromDb['datum'] = parse(povraciloFromDb['datum'], settings.dbDtFormat);
				}
			}
			for (let dodatnaOpremaFromDb of response.data['mapa']['dodatneopreme']) {
				if (dodatnaOpremaFromDb['datum_narocila']) {
					dodatnaOpremaFromDb['datum_narocila'] = parse(dodatnaOpremaFromDb['datum_narocila'], settings.dbDtFormat);
				}
			}
			return response.data;
		});
	},
	saveMapaUserPotrdil (itemId) {
		let args = {
			item: itemId
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/mapa_user_potrdil', args).then(response => {
			if (!response.data || response.data === false) {
				return null;
			}
			return response.data;
		});
	},
	mapaRemoveUserPotrdil (itemId, removeAkcija) {
		let args = {
			item: itemId,
			akcija: removeAkcija
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/mapa_remove_user_potrdil', args).then(response => {
			if (!response.data || response.data === false) {
				return null;
			}
			return response.data;
		});
	},
	getMFilesInfo (itemId) {
		let args = {
			itemId
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/mfiles_info', args).then(response => {
			return response.data;
		});
	},
	priliviUpload (tipPriliva, importText, importFile) {
		let args = new FormData();
		args.append('tip_priliva', tipPriliva);
		if (importText) {
			args.append('import_text', importText);
		}
		if (importFile) {
			args.append('import_file', importFile, importFile.name);
		}
		let settings = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/prilivi_upload', args, settings).then(response => {
			return response.data;
		});
	},
	priliviSave (items) {
		let args = {
			items: items
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/prilivi_save', args).then(response => {
			return response.data;
		});
	},
	removePriliv (id) {
		let args = {
			id: id
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/remove_priliv', args).then(response => {
			return response.data;
		});
	},
	getPriliviFiltered (ctx, filter, user) {
		let query = 'page=' + encodeURIComponent(ctx.currentPage);
		query += '&size=' + encodeURIComponent(ctx.perPage);
		query += '&sort=' + encodeURIComponent(ctx.sortBy);
		query += '&desc=' + encodeURIComponent(ctx.sortDesc);
		query += '&search=' + encodeURIComponent(ctx.filter);
		if (filter.datum) {
			query += '&datumstart=' + format(filter.datum.start, settings.inputDtFormat) + '&datumend=' + format(filter.datum.end, settings.inputDtFormat);
		}
		query += '&ogrodje=' + encodeURIComponent(filter.ogrodje);
		query += '&placnik=' + encodeURIComponent(filter.placnik);
		query += '&naziv=' + encodeURIComponent(filter.naziv);
		query += '&referenca=' + encodeURIComponent(filter.referenca);
		if (filter.znesek) {
			if (filter.znesek.value) {
				query += '&znesek=' + encodeURIComponent(filter.znesek.value);
			} else if (filter.znesek.min && filter.znesek.max) {
				query += '&znesek[]=' + encodeURIComponent(filter.znesek.min);
				query += '&znesek[]=' + encodeURIComponent(filter.znesek.max);
			}
		}
		if (filter.vir) {
			for (let item of filter.vir) {
				query += '&vir[]=' + encodeURIComponent(item);
			}
		}
		query += '&user_id=' + encodeURIComponent(user.dbid);
		query += '&user_role=' + encodeURIComponent(user.role);
		return axios.get(process.env.API_BASE_URL + 'api/v1/get_prilivi_filtered?' + query).then(response => {
			return response.data;
		});
	},
	addPriliv (priliv) {
		if (priliv['datum']) {
			priliv['datum'] = format(priliv['datum'], settings.dbDtFormat);
		}
		let args = {
			id: priliv['id'],
			id_vozila: priliv['id_vozila'],
			datum: priliv['datum'],
			naziv: priliv['naziv'],
			referenca: priliv['referenca'],
			znesek: priliv['znesek'],
			placnik: priliv['placnik']
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/add_priliv', args).then(response => {
			return response.data;
		});
	},
	povracilaUpload (tipPovracila, importFile) {
		let args = new FormData();
		args.append('tip_povracila', tipPovracila);
		if (importFile) {
			args.append('import_file', importFile, importFile.name);
		}
		let settings = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/povracila_data_upload', args, settings).then(response => {
			return response.data;
		});
	},
	povracilaSave (items) {
		let args = {
			items: items
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/povracila_data_save', args).then(response => {
			return response.data;
		});
	},
	getPovracilaFiltered (ctx, filter, user) {
		let query = 'page=' + encodeURIComponent(ctx.currentPage);
		query += '&size=' + encodeURIComponent(ctx.perPage);
		query += '&sort=' + encodeURIComponent(ctx.sortBy);
		query += '&desc=' + encodeURIComponent(ctx.sortDesc);
		query += '&search=' + encodeURIComponent(ctx.filter);
		if (filter.datum) {
			query += '&datumstart=' + format(filter.datum.start, settings.inputDtFormat) + '&datumend=' + format(filter.datum.end, settings.inputDtFormat);
		}
		if (filter.chassis) {
			query += '&chassis=' + encodeURIComponent(filter.chassis);
		}
		if (filter.action_name) {
			query += '&action_name=' + encodeURIComponent(filter.action_name);
		}
		if (filter.sale_channel) {
			query += '&sale_channel=' + encodeURIComponent(filter.sale_channel);
		}
		if (filter.amount) {
			if (filter.amount.value) {
				query += '&amount=' + encodeURIComponent(filter.amount.value);
			} else if (filter.amount.min && filter.amount.max) {
				query += '&amount[]=' + encodeURIComponent(filter.amount.min);
				query += '&amount[]=' + encodeURIComponent(filter.amount.max);
			}
		}
		if (filter.statusPovracila) {
			for (let item of filter.statusPovracila) {
				query += '&status[]=' + encodeURIComponent(item);
			}
		}
		query += '&user_id=' + encodeURIComponent(user.dbid);
		query += '&user_role=' + encodeURIComponent(user.role);
		return axios.get(process.env.API_BASE_URL + 'api/v1/get_povracila_filtered?' + query).then(response => {
			return response.data;
		});
	},
	removePovracilo (id) {
		let args = {
			id: id
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/remove_povracilo', args).then(response => {
			return response.data;
		});
	},
	addPovracilo (povraciloData) {
		if (povraciloData['creditnotedate']) {
			povraciloData['creditnotedate'] = format(povraciloData['creditnotedate'], settings.dbDtFormat);
		}
		let args = {
			id: povraciloData['id'],
			id_vozila: povraciloData['id_vozila'],
			creditnotedate: povraciloData['creditnotedate'],
			opomba: povraciloData['opomba'],
			status: povraciloData['status'],
			chassis: povraciloData['chassis'],
			policy: povraciloData['policy'],
			campaign: povraciloData['campaign'],
			action_name: povraciloData['action_name'],
			sale_channel: povraciloData['sale_channel'],
			month: povraciloData['month'],
			amount: povraciloData['amount'],
			numdoc: povraciloData['numdoc'],
			dealer_name: povraciloData['dealer_name'],
			discount: povraciloData['discount'],
			contribution: povraciloData['contribution'],
			v2_vozilo_opis: povraciloData['v2_vozilo_opis'],
			v2_gc: povraciloData['v2_gc'],
			v2_gc_odobreno: povraciloData['v2_gc_odobreno'],
			v2_marza_opcij: povraciloData['v2_marza_opcij'],
			v2_marza_opcij_odobreno: povraciloData['v2_marza_opcij_odobreno'],
			v2_dmv_dacia_zahtevano: povraciloData['v2_dmv_dacia_zahtevano'],
			v2_dmv_dacia_odobreno: povraciloData['v2_dmv_dacia_odobreno'],
			v2_ka1_naziv: povraciloData['v2_ka1_naziv'],
			v2_ka1_zahtevano: povraciloData['v2_ka1_zahtevano'],
			v2_ka1_odobreno: povraciloData['v2_ka1_odobreno'],
			v2_ka2_naziv: povraciloData['v2_ka2_naziv'],
			v2_ka2_zahtevano: povraciloData['v2_ka2_zahtevano'],
			v2_ka2_odobreno: povraciloData['v2_ka2_odobreno'],
			v2_ka3_naziv: povraciloData['v2_ka3_naziv'],
			v2_ka3_zahtevano: povraciloData['v2_ka3_zahtevano'],
			v2_ka3_odobreno: povraciloData['v2_ka3_odobreno'],
			v2_skupaj_zahtevano: povraciloData['v2_skupaj_zahtevano'],
			v2_komentar: povraciloData['v2_komentar'],
			v2_komentar_uvoznik: povraciloData['v2_komentar_uvoznik']
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/add_povracilo', args).then(response => {
			return response.data;
		});
	},
	relateVoziloPovracilo (ogrodje, idPovracila) {
		let args = {
			ogrodje: ogrodje,
			idPovracila: idPovracila
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/relate_vozilo_povracilo', args).then(response => {
			return response.data;
		});
	},
	saveVozilo (data) {
		let itemData = { };
		itemData = Object.assign(itemData, data);
		if (itemData['predvideni_mada']) {
			itemData['predvideni_mada'] = format(itemData['predvideni_mada'], settings.vozilaImportDFormat);
		} if (itemData['realni_mada']) {
			itemData['realni_mada'] = format(itemData['realni_mada'], settings.vozilaImportDFormat);
		} if (itemData['datum_zps']) {
			itemData['datum_zps'] = format(itemData['datum_zps'], settings.vozilaImportDFormat);
		} if (itemData['datum_zds']) {
			itemData['datum_zds'] = format(itemData['datum_zds'], settings.vozilaImportDFormat);
		} if (itemData['realni_madc']) {
			itemData['realni_madc'] = format(itemData['realni_madc'], settings.vozilaImportDFormat);
		} if (itemData['predvideni_madc']) {
			itemData['predvideni_madc'] = format(itemData['predvideni_madc'], settings.vozilaImportDFormat);
		} if (itemData['datum_fakturiranja']) {
			itemData['datum_fakturiranja'] = format(itemData['datum_fakturiranja'], settings.vozilaImportDFormat);
		} if (itemData['datum_ddk']) {
			itemData['datum_ddk'] = format(itemData['datum_ddk'], settings.vozilaImportDFormat);
		} if (itemData['datum_kddk']) {
			itemData['datum_kddk'] = format(itemData['datum_kddk'], settings.vozilaImportDFormat);
		} if (itemData['datum_vnosa_nk']) {
			itemData['datum_vnosa_nk'] = format(itemData['datum_vnosa_nk'], settings.vozilaImportDFormat);
		} if (itemData['dejanski_datum_dodelitve']) {
			itemData['dejanski_datum_dodelitve'] = format(itemData['dejanski_datum_dodelitve'], settings.vozilaImportDFormat);
		} if (itemData['dejanski_datum_stornacije']) {
			itemData['dejanski_datum_stornacije'] = format(itemData['dejanski_datum_stornacije'], settings.vozilaImportDFormat);
		} if (itemData['datum_izhoda_iz_oc']) {
			itemData['datum_izhoda_iz_oc'] = format(itemData['datum_izhoda_iz_oc'], settings.vozilaImportDFormat);
		} if (itemData['koncesija_datum']) {
			itemData['koncesija_datum'] = format(itemData['koncesija_datum'], settings.vozilaImportDFormat);
		} if (itemData['realni_ara']) {
			itemData['realni_ara'] = format(itemData['realni_ara'], settings.vozilaImportDFormat);
		} if (itemData['datum_prve_registracije']) {
			itemData['datum_prve_registracije'] = format(itemData['datum_prve_registracije'], settings.vozilaImportDFormat);
		} if (itemData['datum_kdaj_ga_lahko_prodamo']) {
			itemData['datum_kdaj_ga_lahko_prodamo'] = format(itemData['datum_kdaj_ga_lahko_prodamo'], settings.vozilaImportDFormat);
		} if (itemData['datum_kdaj_ga_moramo_prodati']) {
			itemData['datum_kdaj_ga_moramo_prodati'] = format(itemData['datum_kdaj_ga_moramo_prodati'], settings.vozilaImportDFormat);
		}
		if (itemData['konto'] !== '') {
			itemData['konto_destinacije'] = itemData['konto'];
		}
		let args = {
			id: itemData['id'],
			ogrodje: itemData['ogrodje'],
			vozilo: itemData['vozilo'],
			st_narocila_vozila: itemData['st_narocila_vozila'],
			st_narocila_kupca: itemData['st_narocila_kupca'],
			libelle_modele: itemData['libelle_modele'],
			libelle_version: itemData['libelle_version'],
			libelle_options: itemData['libelle_options'],
			libelle_teinte: itemData['libelle_teinte'],
			libelle_harmonie: itemData['libelle_harmonie'],
			libelle_sellerie: itemData['libelle_sellerie'],
			source_file: itemData['source_file'],
			st_nm: itemData['st_nm'],
			konto_lastnika: itemData['konto_lastnika'],
			drzava_fiche_gamme: itemData['drzava_fiche_gamme'],
			tip_narocila_vozila: itemData['tip_narocila_vozila'],
			vozilo_na_borzi: itemData['vozilo_na_borzi'],
			obljubljeni_mada: itemData['obljubljeni_mada'],
			predvideni_mada: itemData['predvideni_mada'],
			staranje: itemData['staranje'],
			realni_mada: itemData['realni_mada'],
			stanje_napredovanja: itemData['stanje_napredovanja'],
			opomba_vozilo: itemData['opomba_vozilo'],
			model: itemData['model'],
			verzija: itemData['verzija'],
			opcije: itemData['opcije'],
			barva: itemData['barva'],
			notranjost: itemData['notranjost'],
			oblazinjenje: itemData['oblazinjenje'],
			nivo_kvalitete: itemData['nivo_kvalitete'],
			sprememba: itemData['sprememba'],
			datum_zps: itemData['datum_zps'],
			datum_zds: itemData['datum_zds'],
			konto_naslovnika: itemData['konto_naslovnika'],
			koda_prodajalca: itemData['koda_prodajalca'],
			realni_madc: itemData['realni_madc'],
			predvideni_madc: itemData['predvideni_madc'],
			pristanisce_vkrcanja: itemData['pristanisce_vkrcanja'],
			ime_ladje: itemData['ime_ladje'],
			rezervirano_vozilo: itemData['rezervirano_vozilo'],
			maskirano_vozilo: itemData['maskirano_vozilo'],
			skrito_vozilo: itemData['skrito_vozilo'],
			viop: itemData['viop'],
			datum_fakturiranja: itemData['datum_fakturiranja'],
			datum_vnosa_nk: itemData['datum_vnosa_nk'],
			datum_ddk: itemData['datum_ddk'],
			datum_kddk: itemData['datum_kddk'],
			kupec: itemData['kupec'],
			konto_agenta_satelita: itemData['konto_agenta_satelita'],
			konto_destinacije: itemData['konto_destinacije'],
			koda_prod: itemData['koda_prod'],
			dejanski_datum_dodelitve: itemData['dejanski_datum_dodelitve'],
			dejanski_datum_stornacije: itemData['dejanski_datum_stornacije'],
			tip_kupca: itemData['tip_kupca'],
			prodajni_kanal: itemData['prodajni_kanal'],
			tip_nm: itemData['tip_nm'],
			ime: itemData['ime'],
			email: itemData['email'],
			telefon_privatni: itemData['telefon_privatni'],
			st_pogodbe_v_advensysu: itemData['st_pogodbe_v_advensysu'],
			stanje_narocila_kupca: itemData['stanje_narocila_kupca'],
			status_kvalitete: itemData['status_kvalitete'],
			realni_ara: itemData['realni_ara'],
			nef: itemData['nef'],
			ddo: itemData['ddo'],
			ddpp: itemData['ddpp'],
			blocage_financier: itemData['blocage_financier'],
			blokada_komerciale: itemData['blokada_komerciale'],
			blokada_cata: itemData['blokada_cata'],
			blokada_kvalitete: itemData['blokada_kvalitete'],
			pgeo_bcv: itemData['pgeo_bcv'],
			koncesija_lokacija: itemData['koncesija_lokacija'],
			koncesija_datum: itemData['koncesija_datum'],
			koncesija_prodajalec: itemData['koncesija_prodajalec'],
			zadrzano_lastnik: itemData['zadrzano_lastnik'],
			interna_opomba: itemData['interna_opomba'],
			akcijski: itemData['akcijski'],
			datum_izhoda_iz_oc: itemData['datum_izhoda_iz_oc'],
			opomba_narocilo_kupca: itemData['opomba_narocilo_kupca'],
			datum_prve_registracije: itemData['datum_prve_registracije'],
			datum_kdaj_ga_lahko_prodamo: itemData['datum_kdaj_ga_lahko_prodamo'],
			datum_kdaj_ga_moramo_prodati: itemData['datum_kdaj_ga_moramo_prodati'],
			st_kilometrov: itemData['st_kilometrov'],
			prodajna_cena: itemData['prodajna_cena']
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/save_vozilo', args).then(response => {
			return response.data;
		});
	},
	exportItemsData (data) {
		let args = {};
		let query = '';
		if (data.exportAll === true) {
			args = {
				exportAll: 1
			};
			query = '?' + this.addFiltersToQueryVozilaFiltered(data.filter, data.user);
		} else {
			args = {
				exportAll: 0,
				items: data.items
			};
		}
		let cfg = {
			responseType: 'blob'
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/export_itemsdata' + query, args, cfg).then(response => {
			return response;
		});
	},
	removeImportdata (id, sourceFile) {
		let args = {
			id: id,
			source_file: sourceFile
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/remove_importdata', args).then(response => {
			return response.data;
		});
	},
	archiveImportdata (id) {
		let args = {
			id: id
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/archive_importdata', args).then(response => {
			return response.data;
		});
	},
	uploadFilesForMapa (importFiles, modalData) {
		let args = new FormData();
		args.append('item', modalData);
		console.log(importFiles)
		if (importFiles) {
			for (let file of importFiles) {
				args.append('import_files[]', file, file.name)
			}
		}
		let settings = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/upload_files_for_mapa', args, settings).then(response => {
			return response.data;
		});
	},
	getFilesOfMapa (item) {
		let args = {
			item: item
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/get_files_of_mapa', args).then(response => {
			return response.data;
		});
	},
	removeFileOfMapa (id) {
		let args = {
			id: id
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/remove_file_of_mapa', args).then(response => {
			return response.data;
		});
	},
	downloadFileOfMapa (id) {
		let args = {
			id: id
		};
		let headers = { 'responseType': 'arraybuffer' }
		return axios.post(process.env.API_BASE_URL + 'api/v1/download_file_of_mapa', args, headers).then(response => {
			return response;
		});
	},
	uvoziNissan (zalogaNissan) {
		let args = {
			zalogaNissan
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/import_nissan', args).then(response => {
			return response.data;
		});
	},
	uvoziVega (vega) {
		let args = {
			vega
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/import_vega', args).then(response => {
			return response.data;
		});
	},
	saveMapaZeljenaIzstavitevRacuna (itemId, zeljeniDatumCas) {
		let args = {
			item: itemId,
			zeljeni_datum: zeljeniDatumCas
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/mapa_zeljeni_racun', args).then(response => {
			if (!response.data || response.data === false) {
				return null;
			}
			return response.data;
		});
	},
	MapaIzstaviRacun (mapaId) {
		let args = {
			mapa_id: mapaId
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/mapa_izstavitev_racuna', args).then(response => {
			return response.data;
		});
	},
	getImportdata (id) {
		let args = {
			id
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/get_importdata', args).then(response => {
			if (!response.data) {
				return null;
			}
			if (!response.data['importdata'] || response.data['importdata'] === false) {
				return null;
			}
			if (response.data['status'] === 'ok') {
				if (response.data['importdata']['realni_mada']) {
					response.data['importdata']['realni_mada'] = parse(response.data['importdata']['realni_mada'], settings.dbDtFormat);
				}
				if (response.data['importdata']['predvideni_mada']) {
					response.data['importdata']['predvideni_mada'] = parse(response.data['importdata']['predvideni_mada'], settings.dbDtFormat);
				}
				if (response.data['importdata']['realni_mada']) {
					response.data['importdata']['realni_mada'] = parse(response.data['importdata']['realni_mada'], settings.dbDtFormat);
				}
				if (response.data['importdata']['datum_zps']) {
					response.data['importdata']['datum_zps'] = parse(response.data['importdata']['datum_zps'], settings.dbDtFormat);
				}
				if (response.data['importdata']['datum_zds']) {
					response.data['importdata']['datum_zds'] = parse(response.data['importdata']['datum_zds'], settings.dbDtFormat);
				}
				if (response.data['importdata']['realni_madc']) {
					response.data['importdata']['realni_madc'] = parse(response.data['importdata']['realni_madc'], settings.dbDtFormat);
				}
				if (response.data['importdata']['predvideni_madc']) {
					response.data['importdata']['predvideni_madc'] = parse(response.data['importdata']['predvideni_madc'], settings.dbDtFormat);
				}
				if (response.data['importdata']['datum_fakturiranja']) {
					response.data['importdata']['datum_fakturiranja'] = parse(response.data['importdata']['datum_fakturiranja'], settings.dbDtFormat);
				}
				if (response.data['importdata']['datum_izhoda_iz_oc']) {
					response.data['importdata']['datum_izhoda_iz_oc'] = parse(response.data['importdata']['datum_izhoda_iz_oc'], settings.dbDtFormat);
				}
				return response.data;
			} else {
				return null;
			}
		});
	},
	getImportdataDistinctByOgrodje (ogrodje) {
		let args = {
			ogrodje
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/get_importdata_distinct_by_ogrodje', args).then(response => {
			if (!response.data) {
				return null;
			}
			if (!response.data['importdata'] || response.data['importdata'] === false) {
				return null;
			}
			if (response.data['status'] === 'ok') {
				if (response.data['importdata']['realni_mada']) {
					response.data['importdata']['realni_mada'] = parse(response.data['importdata']['realni_mada'], settings.dbDtFormat);
				}
				if (response.data['importdata']['predvideni_mada']) {
					response.data['importdata']['predvideni_mada'] = parse(response.data['importdata']['predvideni_mada'], settings.dbDtFormat);
				}
				if (response.data['importdata']['realni_mada']) {
					response.data['importdata']['realni_mada'] = parse(response.data['importdata']['realni_mada'], settings.dbDtFormat);
				}
				if (response.data['importdata']['datum_zps']) {
					response.data['importdata']['datum_zps'] = parse(response.data['importdata']['datum_zps'], settings.dbDtFormat);
				}
				if (response.data['importdata']['datum_zds']) {
					response.data['importdata']['datum_zds'] = parse(response.data['importdata']['datum_zds'], settings.dbDtFormat);
				}
				if (response.data['importdata']['realni_madc']) {
					response.data['importdata']['realni_madc'] = parse(response.data['importdata']['realni_madc'], settings.dbDtFormat);
				}
				if (response.data['importdata']['predvideni_madc']) {
					response.data['importdata']['predvideni_madc'] = parse(response.data['importdata']['predvideni_madc'], settings.dbDtFormat);
				}
				if (response.data['importdata']['datum_fakturiranja']) {
					response.data['importdata']['datum_fakturiranja'] = parse(response.data['importdata']['datum_fakturiranja'], settings.dbDtFormat);
				}
				if (response.data['importdata']['datum_izhoda_iz_oc']) {
					response.data['importdata']['datum_izhoda_iz_oc'] = parse(response.data['importdata']['datum_izhoda_iz_oc'], settings.dbDtFormat);
				}
				return response.data;
			} else {
				return null;
			}
		});
	},
	// HOTEL GUM
	hotelHrambaEdit (hotelHramba) {
		let config = {
			timeout: settings.responseTimeout
		}
		let args = {
			id: hotelHramba.id,
			fk_hotel_stranka: hotelHramba.fk_hotel_stranka,
			fk_hotel_lokacija: hotelHramba.fk_hotel_lokacija
		}
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_hramba_edit', args, config).then(response => {
			return response.data;
		});
	},
	getHotelHrambeFiltered (ctx, inputFilter) {
		let config = {
			timeout: settings.responseTimeout
		}
		let query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		if (inputFilter.id) {
			query += '&id=' + encodeURIComponent(inputFilter.id);
		}
		if (inputFilter.title) {
			query += '&title=' + encodeURIComponent(inputFilter.title);
		}
		if (inputFilter.email) {
			query += '&email=' + encodeURIComponent(inputFilter.email);
		}
		if (inputFilter.registration_number) {
			query += '&registration_number=' + encodeURIComponent(inputFilter.registration_number);
		}
		if (inputFilter.vehicle) {
			query += '&vehicle=' + encodeURIComponent(inputFilter.vehicle);
		}
		if (inputFilter.hotelLokacija) {
			query += '&hotelLokacija=' + encodeURIComponent(inputFilter.hotelLokacija);
		}
		if (inputFilter.external != null) {
			query += '&external=' + encodeURIComponent(inputFilter.external);
		}
		if (inputFilter.datumStoritve) {
			query += '&datumstart=' + format(inputFilter.datumStoritve.start, settings.inputDtFormat) + '&datumend=' + format(inputFilter.datumStoritve.end, settings.inputDtFormat);
		}
		if (inputFilter.dimensionsWidth) {
			query += '&dimensionsWidth=' + encodeURIComponent(inputFilter.dimensionsWidth);
		}
		if (inputFilter.dimensionsHeight) {
			query += '&dimensionsHeight=' + encodeURIComponent(inputFilter.dimensionsHeight);
		}
		if (inputFilter.dimensionsDiameter) {
			query += '&dimensionsDiameter=' + encodeURIComponent(inputFilter.dimensionsDiameter);
		}
		if (inputFilter.season) {
			for (let item of inputFilter.season) {
				query += '&season[]=' + encodeURIComponent(item);
			}
		}
		if (inputFilter.statusHotelHramba != null) {
			query += '&statusHotelHramba=' + encodeURIComponent(inputFilter.statusHotelHramba);
		}
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_hrambe_list_filtered?' + query, config).then(response => {
			return response.data;
		});
	},
	hotelLokacijaEdit (hotelHramba) {
		let config = {
			timeout: settings.responseTimeout
		}
		let args = {
			id: hotelHramba.id,
			title: hotelHramba.title
		}
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_lokacija_edit', args, config).then(response => {
			return response.data;
		});
	},
	getHotelLokacijeFiltered (ctx, inputFilter) {
		let config = {
			timeout: settings.responseTimeout
		}
		let query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		if (inputFilter.title) {
			query += '&title=' + encodeURIComponent(inputFilter.title);
		}
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_lokacije_list_filtered?' + query, config).then(response => {
			return response.data;
		});
	},
	searchHotelLokacije (data) {
		let args = {
			qs: data.qs,
			freeOnly: data.freeOnly
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/search_hotel_lokacije', args).then(response => {
			return response.data;
		});
	},
	removeHotelLokacija (id) {
		let config = {
			timeout: settings.responseTimeout
		}
		let args = {
			id: id
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_lokacija_remove', args, config).then(response => {
			return response.data;
		});
	},
	hotelStoritevEdit (hotelStoritev, mode, initHotelKomentarji) {
		let config = {
			timeout: settings.responseTimeout
		}
		let args = {
			mode,
			id: hotelStoritev.id,
			fk_hotel_hramba: hotelStoritev.fk_hotel_hramba,
			fk_hotel_stranka: hotelStoritev.fk_hotel_stranka,
			num_tires: hotelStoritev.num_tires,
			dimensions: JSON.stringify(hotelStoritev.dimensions),
			manufacturer: hotelStoritev.manufacturer,
			season: hotelStoritev.season,
			rims: hotelStoritev.rims,
			rims_cover: hotelStoritev.rims_cover,
			rims_screw: hotelStoritev.rims_screw,
			year: hotelStoritev.year,
			wear: hotelStoritev.wear,
			note_give: hotelStoritev.note_give,
			responsible_mechanic_give: hotelStoritev.responsible_mechanic_give,
			date_give: hotelStoritev.date_give != null ? format(hotelStoritev.date_give, settings.dbDtFormat) : null,
			note_take: hotelStoritev.note_take,
			responsible_mechanic_take: hotelStoritev.responsible_mechanic_take,
			date_take: hotelStoritev.date_take != null ? format(hotelStoritev.date_take, settings.dbDtFormat) : null,
			fk_hotel_storitev_take: hotelStoritev.fk_hotel_storitev_take,
			initHotelKomentarji: mode === 1 || mode === 3 ? initHotelKomentarji : null
		}
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_storitev_edit', args, config).then(response => {
			return response.data;
		});
	},
	getHotelStoritveFiltered (ctx, inputFilter) {
		let config = {
			timeout: settings.responseTimeout
		}
		let query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		query += '&with_archived=' + encodeURIComponent(inputFilter.with_archived);
		if (inputFilter.fk_hotel_hramba) {
			query += '&fk_hotel_hramba=' + encodeURIComponent(inputFilter.fk_hotel_hramba);
		}
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_storitve_list_filtered?' + query, config).then(response => {
			return response.data;
		});
	},
	hotelStoritevInitParams (params) {
		let config = {
			timeout: settings.responseTimeout
		}
		let args = {
			manufacturer: params.manufacturer
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_storitve_init_params', args, config).then(response => {
			return response.data;
		});
	},
	exportHotelStoritev (id) {
		let args = {
			id
		};
		let cfg = {
			responseType: 'blob'
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_storitev_export_pdf', args, cfg).then(response => {
			return response;
		});
	},
	hotelKomentarEdit (hotelKomentar) {
		let config = {
			timeout: settings.responseTimeout
		}
		let args = {
			id: hotelKomentar.id,
			linked_to: hotelKomentar.linked_to,
			content: hotelKomentar.content
		}
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_komentar_edit', args, config).then(response => {
			return response.data;
		});
	},
	getHotelKomentarjiFiltered (ctx, inputFilter) {
		let config = {
			timeout: settings.responseTimeout
		}
		let query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		if (inputFilter.linked_to) {
			query += '&linked_to=' + encodeURIComponent(inputFilter.linked_to);
		}
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_komentarji_list_filtered?' + query, config).then(response => {
			return response.data;
		});
	},
	searchHotelStranke (qs) {
		let args = {
			qs
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_stranke_search', args).then(response => {
			return response.data;
		});
	},
	hotelStrankaEdit (hotelStranka) {
		let config = {
			timeout: settings.responseTimeout
		}
		let args = {
			id: hotelStranka.id,
			first_name: hotelStranka.first_name,
			last_name: hotelStranka.last_name,
			title: hotelStranka.title,
			email: hotelStranka.email,
			phone_number: hotelStranka.phone_number,
			address: hotelStranka.address,
			city: hotelStranka.city,
			registration_number: hotelStranka.registration_number,
			vehicle: hotelStranka.vehicle,
			external: hotelStranka.external,
			is_company: hotelStranka.is_company
		}
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_stranka_edit', args, config).then(response => {
			return response.data;
		});
	},
	hotelHrambaConfirm (data) {
		let config = {
			timeout: settings.responseTimeout
		}
		let args = {
			items: data.items
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_hramba_confirm', args, config).then(response => {
			return response.data;
		});
	},
	hotelHrambaResetConfirmations () {
		let config = {
			timeout: settings.responseTimeout
		}
		return axios.post(process.env.API_BASE_URL + 'api/v1/hotel_hramba_reset_confirmations', config).then(response => {
			return response.data;
		});
	},
	// CDP Vehicles stock
	cdpVehiclesStockListFiltered (ctx, inputFilter) {
		let config = {
			timeout: settings.responseTimeout
		}
		let query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		if (inputFilter.number) {
			query += '&number=' + encodeURIComponent(inputFilter.number);
		}
		if (inputFilter.vin) {
			query += '&vin=' + encodeURIComponent(inputFilter.vin);
		}
		if (inputFilter.registration_number) {
			query += '&registration_number=' + encodeURIComponent(inputFilter.registration_number);
		}
		if (inputFilter.model) {
			for (let item of inputFilter.model) {
				query += '&model[]=' + encodeURIComponent(item);
			}
		}
		if (inputFilter.kind) {
			for (let item of inputFilter.kind) {
				query += '&kind[]=' + encodeURIComponent(item);
			}
		}
		if (inputFilter.location) {
			for (let item of inputFilter.location) {
				query += '&location[]=' + encodeURIComponent(item);
			}
		}
		if (inputFilter.payment_required_only) {
			query += '&payment_required_only=' + encodeURIComponent(inputFilter.payment_required_only);
		}
		if (inputFilter.due_date) {
			query += '&due_date_start=' + format(inputFilter.due_date.start, settings.inputDtFormat) + '&due_date_end=' + format(inputFilter.due_date.end, settings.inputDtFormat);
		}
		if (inputFilter.invoice_number) {
			query += '&invoice_number=' + encodeURIComponent(inputFilter.invoice_number);
		}
		if (inputFilter.paid) {
			query += '&paid=' + encodeURIComponent(inputFilter.paid);
		}
		return axios.post(process.env.API_BASE_URL + 'api/v1/cdp_vehicles_stock_list_filtered?' + query, config).then(response => {
			return response.data;
		});
	},
	cdpVehiclesStockImport (newVehicles, usedVehicles, dmv) {
		let args = {
			newVehicles,
			usedVehicles,
			dmv
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/cdp_vehicles_stock_import', args).then(response => {
			return response.data;
		});
	},
	cdpTraficImport (trafic) {
		let args = {
			trafic
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/cdp_vehicles_trafic_import', args).then(response => {
			return response.data;
		});
	},
	cdpVehicleStockSetPaid (id) {
		let args = {
			id
		};
		return axios.post(process.env.API_BASE_URL + 'api/v1/cdp_vehicles_stock_set_paid', args).then(response => {
			return response;
		});
	},
	cdpVehicleStockGetLocations () {
		return axios.get(process.env.API_BASE_URL + 'api/v1/cdp_vehicles_get_locations').then(response => {
			return response.data;
		});
	},
}
export default service



// WEBPACK FOOTER //
// ./src/service/index.js